import React from "react";

const STATUS_COLORS = {
  400: "bg-amber-100 text-amber-700",
  401: "bg-red-100 text-red-600",
  403: "bg-red-100 text-red-600",
  404: "bg-amber-100 text-amber-700",
  429: "bg-orange-100 text-orange-700",
  500: "bg-red-100 text-red-600",
  502: "bg-red-100 text-red-600",
  503: "bg-purple-100 text-purple-700",
};

const ErrorReference = ({ errors }) => {
  if (!errors || errors.length === 0) return null;

  return (
    <div id="error-codes" className="scroll-mt-6">
      <h1>Error Reference</h1>
      <p className="apidocs-lead">
        All API errors follow a consistent format. Use the error code and message to diagnose issues.
      </p>

      <div className="mb-5 bg-[#0d1117] border border-gray-800 rounded-lg p-4">
        <span className="text-[10px] font-semibold uppercase tracking-wider text-gray-500 mb-2 block">Error Response Format</span>
        <pre className="apidocs-pre">{`{
  "success": false,
  "error": {
    "code": "ERROR_CODE",
    "message": "Human-readable error description"
  }
}`}</pre>
      </div>

      <div className="space-y-3">
        {errors.map((err) => (
          <div key={err.code} className="border border-gray-200 rounded-xl overflow-hidden">
            <div className="flex items-center gap-3 px-4 py-3 bg-gray-50 border-b border-gray-100">
              <code className="text-xs font-bold font-mono text-gray-800">{err.code}</code>
              <span className={`px-1.5 py-0.5 rounded text-[10px] font-bold ${STATUS_COLORS[err.status] || "bg-gray-100 text-gray-600"}`}>
                {err.status}
              </span>
            </div>
            <div className="px-4 py-3 space-y-2">
              <p className="text-sm text-gray-600">{err.message}</p>
              <div className="flex gap-2 items-start">
                <span className="text-[10px] font-semibold uppercase tracking-wider text-emerald-600 mt-0.5 flex-shrink-0">Fix:</span>
                <p className="text-xs text-gray-500 leading-relaxed">{err.solution}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ErrorReference;
